import type {
  CallCenter,
  GetContactsRequest,
} from '@/apis/generated/dialpad-contact';
import { CallCenterFromJSON } from '@/apis/generated/dialpad-contact';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

type CallCenterFilter = Pick<GetContactsRequest, 'search' | 'limit'>;

// Hiding hardcoded props from the store
export type CallCenterStore = StoreEntity<
  CallCenter,
  'shortKey',
  CallCenterFilter
>;

const PROJECTION = [
  'short_key',
  'key',
  'group_id',
  'name',
  'dids_details',
  'state',
  'group',
  'office_id',
].join(',');

export const useCallCenterStore = apiStoreFactory<
  CallCenterStore['entity'],
  CallCenterStore['id'],
  CallCenterStore['filter'],
  CallCenterStore['createInput']
>(
  STORE.CALL_CENTER,
  { entityIdKey: 'shortKey', supportPagination: false },
  {
    readAll: async (filter, { contactApi }, signal) => {
      return await contactApi.getContactsRaw(
        {
          ...filter,
          limit: filter.limit ?? 100,
          type: 'call_center',
          filter: 'group',
          projection: PROJECTION,
        },
        { signal },
      );
    },
    read: async (id, { contactApi }) => {
      return await contactApi.getContact({
        contactKey: id,
        projection: '',
      });
    },
    bulkRead: async (keys, { contactApi }) => {
      const contacts = await contactApi.getModelsByKeys({
        keys: keys.join(','),
        projection: PROJECTION,
        excludeSoftDeleted: false,
      });
      return contacts.map(CallCenterFromJSON);
    },
  },
);
